export default __webpack_public_path__ + "static/media/2-4.d9f28968.jpg";